import * as React from 'react';
import { Image } from '@bytebrand/fe-ui-core-autobahn/compat';
import Slider from 'react-slick';
import styles from './ThumbsList.styl';
import classNames from 'classnames';
export const ThumbsList = React.forwardRef((props, ref) => {
    const { activeSlide, photos, onClick, thumbsToShow, showYoutube } = props;
    const settings = {
        arrows: photos.length > thumbsToShow,
        autoPlay: false,
        centerMode: photos.length > thumbsToShow,
        dots: false,
        infinite: photos.length > thumbsToShow,
        initialSlide: activeSlide,
        lazyLoad: 'ondemand',
        slidesToScroll: 1,
        slidesToShow: photos.length > thumbsToShow ? thumbsToShow : thumbsToShow + 1,
        speed: 300,
        draggable: false
    };
    function handleClickThumb(index) {
        return () => {
            onClick(index);
        };
    }
    const addSrc = (thumb) => {
        if (showYoutube && thumb.videoUrl) {
            return `//img.youtube.com/vi/${thumb.videoUrl}/0.jpg`;
        }
        else if (!showYoutube && thumb.videoUrl) {
            return '';
        }
        else {
            return thumb.imageUrlSmall;
        }
    };
    return (React.createElement("div", { className: styles.ThumbsList },
        React.createElement(Slider, { ...settings, ref: ref }, photos.map((thumb, index) => {
            const thumbClasses = classNames({ [styles.activeVideo]: index === activeSlide }, { [styles.video]: thumb.videoUrl });
            const thumbProps = {
                onClick: handleClickThumb(index),
                width: `100%`,
                ratioW: 4,
                ratioH: 3,
                src: addSrc(thumb),
                className: index === activeSlide ? styles.active : null
            };
            return (React.createElement("div", { className: thumbClasses, key: index },
                React.createElement(Image, { ...thumbProps, key: index })));
        }))));
});
